module.exports = __webpack_public_path__ + "img/u-realnewaddress.523ac4ae.png";